export default () => window.matchMedia("(display-mode: standalone)").matches
